import React from "react";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import PageSeo from "../SEO/PageSeo";
import {
  FaRobot,
  FaCogs,
  FaGlobe,
  FaPenFancy,
  FaWhatsapp,
  FaTelegramPlane,
} from "react-icons/fa";
import { WA_LINK, TG_LINK } from "../../config/contactLinks";
import { useLanguage } from "../../context/LanguageContext";
import { useMessengerLinks } from "../../hooks/useMessengerLinks";
import PortfolioSection from "../Portfolio/PortfolioSection";

function Home() {
  const { t } = useLanguage();
  const links = useMessengerLinks();
  const faqRaw = t("faq.items");
  const faqList = Array.isArray(faqRaw) ? faqRaw : [];

  return (
    <section>
      <PageSeo
        title={t("seo.home.title")}
        description={t("seo.home.description")}
        faqItems={faqList}
      />

      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <p className="broxe-offer text-white-50 mb-2 ps-md-5 ps-3">
                {t("hero.offer")}
              </p>
              <h1 style={{ paddingBottom: 15 }} className="heading">
                {t("hero.h1a")}
                <span className="purple">{t("hero.h1b")}</span>
              </h1>
              <h2 className="heading-name h4 text-white fw-normal ps-md-5 ps-3">
                {t("hero.h2")}
              </h2>
              <div className="broxe-hero-cta d-grid gap-2 d-md-flex flex-md-row flex-wrap align-items-md-start ps-md-5 ps-3 pb-3 pt-4">
                <Button
                  variant="primary"
                  size="lg"
                  className="w-100 w-md-auto me-md-2"
                  as="a"
                  href={links.waReview}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("hero.ctaReview")}
                </Button>
                <Button
                  variant="outline-light"
                  size="lg"
                  className="w-100 w-md-auto"
                  as="a"
                  href={links.tgContact}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("hero.ctaContact")}
                </Button>
              </div>
            </Col>
            <Col
              md={5}
              className="text-center mt-4 mt-md-0 d-flex align-items-center justify-content-center"
            >
              <img
                src={homeLogo}
                alt={t("hero.imgAlt")}
                className="img-fluid broxe-hero-img"
              />
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="broxe-section broxe-solution">
        <Container>
          <Row className="align-items-center">
            <Col lg={7}>
              <h2 className="broxe-section-title">
                {t("solution.beforeBrand")}
                <img
                  src={`${process.env.PUBLIC_URL}/logo/big-logo.png`}
                  alt={t("seo.siteName")}
                  className="broxe-title-logo"
                />
                {t("solution.afterBrand")}
              </h2>
              <p className="text-white lead">{t("solution.lead")}</p>
              <ul className="broxe-list text-white-50">
                <li>{t("solution.l1")}</li>
                <li>{t("solution.l2")}</li>
                <li>{t("solution.l3")}</li>
              </ul>
              <Button
                variant="primary"
                className="w-100 w-md-auto mt-2 mt-md-0"
                as="a"
                href={links.waConsult}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("solution.ctaConsult")}
              </Button>
            </Col>
            <Col lg={5} className="mt-4 mt-lg-0">
              <div className="broxe-card">
                <p className="text-white mb-0 fst-italic">{t("solution.quote")}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="broxe-section broxe-services-preview">
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h2 className="broxe-section-title">
                {t("servicesPrev.beforeH")}
                <span className="purple">{t("servicesPrev.highlight")}</span>
                {t("servicesPrev.afterH")}
              </h2>
              <p className="text-white-50">{t("servicesPrev.intro")}</p>
            </Col>
          </Row>
          <Row>
            <Col md={6} lg={3} className="mb-4">
              <div className="broxe-card broxe-service-icon text-center h-100">
                <FaRobot className="purple mb-3" size={42} aria-hidden />
                <h3 className="h5 text-white">{t("servicesPrev.s1t")}</h3>
                <p className="text-white-50 small mb-0">{t("servicesPrev.s1d")}</p>
              </div>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <div className="broxe-card broxe-service-icon text-center h-100">
                <FaCogs className="purple mb-3" size={42} aria-hidden />
                <h3 className="h5 text-white">{t("servicesPrev.s2t")}</h3>
                <p className="text-white-50 small mb-0">{t("servicesPrev.s2d")}</p>
              </div>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <div className="broxe-card broxe-service-icon text-center h-100">
                <FaGlobe className="purple mb-3" size={42} aria-hidden />
                <h3 className="h5 text-white">{t("servicesPrev.s3t")}</h3>
                <p className="text-white-50 small mb-0">{t("servicesPrev.s3d")}</p>
              </div>
            </Col>
            <Col md={6} lg={3} className="mb-4">
              <div className="broxe-card broxe-service-icon text-center h-100">
                <FaPenFancy className="purple mb-3" size={42} aria-hidden />
                <h3 className="h5 text-white">{t("servicesPrev.s4t")}</h3>
                <p className="text-white-50 small mb-0">{t("servicesPrev.s4d")}</p>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center mt-2">
            <Col className="col-12 col-sm-auto text-center px-3">
              <Button variant="outline-light" className="w-100 w-sm-auto" as={Link} to="/services">
                {t("servicesPrev.btn")}
              </Button>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="broxe-section broxe-process">
        <Container>
          <Row className="mb-4 text-center">
            <Col>
              <h2 className="broxe-section-title">
                {t("process.beforeH")}
                <span className="purple">{t("process.highlight")}</span>
              </h2>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="mb-4 text-center">
              <div className="broxe-step">1</div>
              <h3 className="h5 text-white">{t("process.p1t")}</h3>
              <p className="text-white-50">{t("process.p1d")}</p>
            </Col>
            <Col md={4} className="mb-4 text-center">
              <div className="broxe-step">2</div>
              <h3 className="h5 text-white">{t("process.p2t")}</h3>
              <p className="text-white-50">{t("process.p2d")}</p>
            </Col>
            <Col md={4} className="mb-4 text-center">
              <div className="broxe-step">3</div>
              <h3 className="h5 text-white">{t("process.p3t")}</h3>
              <p className="text-white-50">{t("process.p3d")}</p>
            </Col>
          </Row>
        </Container>
      </Container>

      <PortfolioSection />

      <Container fluid className="broxe-section broxe-faq" id="faq">
        <Container>
          <Row className="mb-4 text-center">
            <Col lg={8} className="mx-auto">
              <h2 className="broxe-section-title">{t("faq.title")}</h2>
              <p className="text-white-50 mb-0">{t("faq.subtitle")}</p>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col lg={9}>
              <Accordion defaultActiveKey="0" flush className="broxe-faq-accordion">
                {faqList.map((item, i) => (
                  <Accordion.Item
                    eventKey={String(i)}
                    key={i}
                    className="broxe-faq-item border-0"
                  >
                    <Accordion.Header className="broxe-faq-header">{item.q}</Accordion.Header>
                    <Accordion.Body className="broxe-faq-body">{item.a}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container fluid className="broxe-section broxe-cta-final">
        <Container>
          <Row className="justify-content-center text-center">
            <Col lg={8}>
              <h2 className="broxe-section-title text-white">{t("ctaFinal.title")}</h2>
              <p className="text-white-50 mb-4">{t("ctaFinal.sub")}</p>
              <div className="d-grid gap-2 d-md-flex flex-md-row flex-wrap justify-content-md-center">
                <Button
                  variant="primary"
                  size="lg"
                  className="w-100 w-md-auto me-md-2"
                  as="a"
                  href={links.waConsult}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("ctaFinal.req")}
                </Button>
                <Button
                  variant="outline-light"
                  size="lg"
                  className="w-100 w-md-auto"
                  as="a"
                  href={links.tgDemo}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("ctaFinal.demo")}
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h2 className="h3">{t("social.title")}</h2>
            <p>
              <span className="purple">WhatsApp</span> {t("social.or")}{" "}
              <span className="purple">Telegram</span>
              {t("social.p2")}
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label={t("homeAria.wa")}
                >
                  <FaWhatsapp />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href={TG_LINK}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label={t("homeAria.tg")}
                >
                  <FaTelegramPlane />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
